var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('PageArticleListCategory',{attrs:{"category":_vm.category,"init-articles":_vm.articles,"init-page":_vm.page,"init-per-page":_vm.perPage,"menu-item":_vm.menuItem,"total":_vm.total}})
}
var staticRenderFns = []

export { render, staticRenderFns }